import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, } from 'react-intl';
import { Container, Grid, Card, Header } from 'semantic-ui-react';
import { UniversalLink, PreviewImage } from '@plone/volto/components';
import { searchContent } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers';
import { isEmpty, map } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { formatDate } from '../../helpers';


const RelatedEquipmentNews = props => {
  const content = props;
  const dispatch = useDispatch();
  const news = useSelector((state) => state.search.subrequests.relatedEquipmentNews?.items);
  const isLoading = useSelector((state) => state.search.subrequests.relatedEquipmentNews?.loading);

  useEffect(() => {
    if (!content?.UID) return;

    const query = {
      portal_type: ['News Item'],
      review_state: 'published',
      related_equipment: content.UID,
      sort_on: 'effective',
      sort_order: 'reverse',
      b_size: 3,
      metadata_fields: ['effective', 'Subject', 'hasPreviewImage',],
    };
    dispatch(searchContent('/', query, 'relatedEquipmentNews'));
  }, [dispatch, content?.UID]);

  if (isLoading) return null;
  if (isEmpty(news)) return null;

  return (
    <div className="newsListing__wrapper relatedEquipmentNews">
      <Header as="h3" className="relatedContent__title h5 mb-4"><FormattedMessage id="Related news" defaultMessage="Related news" /></Header>
      <Container className="news newsListing pt-1">
        <Grid className="mb-4">
          <Grid.Row columns={12}>
            {news.map((item) => (
              <Grid.Column
                className="mb-4"
                mobile={12}
                tablet={6}
                computer={4}
                widescreen={4}
                key={item['@id']}
              >
                <Card fluid as="article" className="newsItem position-relative">
                  {item.image_field && (
                    <div className="newsItem__figure">
                      <PreviewImage
                        className="newsItem__img m-0 image"
                        item={item}
                        alt={item.image_caption ? item.image_caption : ''}
                        sizes="(max-width: 767px) 100vw, (max-width: 991px) 50vw, 33.33vw"
                      />
                    </div>
                  )}

                  <Card.Content className="newsItem__text">
                    <Card.Meta className="newsItem__extra">
                      {item.effective && (
                        <span className="newsItem__date">
                          <FontAwesomeIcon
                            icon={faCalendar}
                            className="readMoreItem__icon me-2"
                          />
                          {formatDate(item.effective)}
                        </span>
                      )}
                    </Card.Meta>

                    <Card.Header className="newsItem__title" as="h2">
                      <UniversalLink
                        className="newsItem__link stretched-link"
                        href={flattenToAppURL(item['@id'])}
                      >
                        {item.title}
                      </UniversalLink>
                    </Card.Header>

                    {item?.description && (
                      <Card.Description
                        as="p"
                        className="newsItem__desc mt-0"
                      >
                        {item.description}
                      </Card.Description>
                    )}

                    <div className="text-end mt-auto">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                  </Card.Content>
                </Card>
              </Grid.Column>
            ))}
          </Grid.Row>
        </Grid>
      </Container>
    </div>
  );
};

export default RelatedEquipmentNews;